import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { APP_BASE_URL } from "../../appconfig/Settings";
import axiosInstance from "../../config/axiosInstance";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
  provinces,
} from "../../appconfig/Settings";
import { UserListColumns } from "../../appconfig/DatatableSetting";
import { deleteData, postAllData, updateData } from "../../service/ProductService";
import { DELETE_USER, GET_USER_LIST, SAVE_USER_DATA, UPDATE_USER_DATA } from "../../config/ApiConstant";
import { validateUserForm } from "../../config/Validate";
import { nameTemplate } from "../../appconfig/TemplateFieldSetting";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { globalNameFilterTemplate } from "../../appconfig/AppHelper";
import { RadioButton } from "primereact/radiobutton";
const ManageUser = () => {
  document.title = "Users | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [userList, setUserList] = useState<any>([]);
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);
  const [addDeleteUserDialog, setAddDeleteUserDialog] = useState<boolean>(false);
  const navigate = useNavigate();

  // deleteid
  const [deleteId, setDeleteId] = useState<any>(null);

  // isedit true false
  const [isEdit, setIsEdit] = useState<boolean>(false);

  // error state
  const [errors, setErrors] = useState<any>({});

  // globaluser data
  // const [globleUserData, setGlobalUserData] = useState<any>({});
  const [globleUserData, setGlobalUserData] = useState<any>({
    client_charge_payment_by: "User",
  });

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },

    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // useefect for get user list
  useEffect(() => {
    getUserList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // get user list api
  const getUserList = async () => {
    try {
      const response = await axiosInstance(APP_BASE_URL + GET_USER_LIST + "?type=User");
      const data = response?.data?.data;
      if (data) {
        setUserList(data);
        setPageLoad(true);
      } else {
        setUserList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <span className="block mr-2 p-input-icon-left">
      <i className="pi pi-search" />
      <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
    </span>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <Button icon="pi pi-filter-slash" label="Clear" onClick={clearAll} className="mr-2 p-button-outlined common-p-outline-button" />
      <Button className="ml-1 common-primary-button" icon="pi pi-plus" label="Add User Data" onClick={() => addEditDialog()} />
    </>
  );

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setDeleteId(deleteID);
    setDeleteDialog(true);
  };

  // delete user api call
  const deleteUser = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_USER, deleteId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        getUserList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // hide delete modal
  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null);
  };

  // add and edit user modal
  const addEditDialog = (rowData: any = null) => {
    if (rowData) {
      setGlobalUserData({ ...rowData });
      setIsEdit(true);
    } else {
      setGlobalUserData({ client_charge_payment_by: "User" });
      setIsEdit(false);
    }
    setErrors({});
    setAddDeleteUserDialog(true);
  };

  // hide add & edit user modal
  const hideAddEditUserDialog = () => {
    setAddDeleteUserDialog(false);
    setSubmitLoading(false);
  };

  // inputvalues set in state
  const onInputChange = (e: any, name: string) => {
    let val = e.target.value;

    // format postal code: add space after 3 characters
    if (name === "postal_code" && val) {
      // remove all spaces first
      val = val.replace(/\s+/g, "").toUpperCase();
      // insert space after 3 characters if length > 3
      if (val.length > 3) {
        val = val.slice(0, 3) + " " + val.slice(3);
      }
    }

    setGlobalUserData({ ...globleUserData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // add & update user api call
  const submitUserForm = async () => {
    const { isError, errors } = validateUserForm(globleUserData);
    setErrors(errors);
    if (isError) return;

    setSubmitLoading(true);
    try {
      const payload = {
        // ...globleUserData,
        first_name: globleUserData?.first_name,
        last_name: globleUserData?.last_name,
        email: globleUserData?.email,
        phone: globleUserData?.phone,
        postal_code: globleUserData?.postal_code,
        address: globleUserData?.address,
        province: globleUserData?.province,
        city: globleUserData?.city,
        client_charge_payment_by: globleUserData?.client_charge_payment_by,

        type: "User",
      };

      const response = isEdit ? await updateData(UPDATE_USER_DATA, globleUserData?.id, payload) : await postAllData(SAVE_USER_DATA, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideAddEditUserDialog();
        getUserList();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-pencil"
        tooltip="Edit"
        className="common-edit-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => addEditDialog(rowData)}
      />
      <Button
        icon="pi pi-trash"
        tooltipOptions={{ position: "bottom" }}
        className="ml-2 p-button-danger common-delete-btn"
        tooltip="Delete"
        onClick={() => confirmDelete(rowData.id)}
      />
    </div>
  );

  // user detail template
  const userDetailTemplate = (rowData: any) => {
    return (
      <Link style={{ textDecoration: "underline", color: "blue" }} to={`/users/clients-list/${btoa(rowData?.id)}`}>
        {rowData.unique_id}
      </Link>
    );
  };

  // user invoice template
  const userInvoiceTemplate = (rowData: any) => {
    return (
      <Button
        label=""
        icon="pi pi-arrow-right"
        tooltip="Client Charge Invoice"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => navigate(`/user-invoice/${btoa(rowData?.id)}`)}
      />
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Users" pageName="List" pageTitle="User List" />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={userList}
                showGridlines
                dataKey="id"
                responsiveLayout={"scroll"}
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={userList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Users"}
                emptyMessage="No Users Found"
                // filters={globalFieldFilter}
                // onFilter={(e) => setGlobalFieldFilter(e.filters)}
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                globalFilterFields={["unique_id", "first_name", "last_name", "email", "phone", "address"]}
                removableSort
              >
                {UserListColumns.map((col, i) => {
                  if (col.field === "name") {
                    return <Column key={col.field} field={col.field} header={col.header} body={nameTemplate} />;
                  } else if (col.field === "unique_id") {
                    return <Column key={col.field} field={col.field} header={col.header} body={userDetailTemplate} />;
                  } else if (col.field === "address") {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  } else if (col.field === "user_invoice") {
                    return <Column key={col.field} field={col.field} header={col.header} body={userInvoiceTemplate} />;
                  } else if (col.field === "action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {UserListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>
      {/* Add/Edit Dialog */}
      <Dialog
        visible={addDeleteUserDialog}
        className="mx-3 lg:mx-0"
        style={{ width: "800px" }}
        header={isEdit ? "Edit User" : "Add User"}
        draggable={false}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideAddEditUserDialog} />
            <Button label="Submit" icon="pi pi-check" onClick={submitUserForm} className="common-primary-button" loading={submitLoading} />
          </div>
        }
        onHide={hideAddEditUserDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* First Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">First Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleUserData.first_name || ""}
                name="first_name"
                autoComplete="off"
                placeholder="Enter First Name"
                onChange={(e) => onInputChange(e, "first_name")}
                className={errors["first_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["first_name"]}</small>
          </div>

          {/* Last Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="name">Last Name *</label>
            <div className="input-effect-div">
              <InputText
                value={globleUserData.last_name || ""}
                name="last_name"
                autoComplete="off"
                placeholder="Enter Last Name"
                onChange={(e) => onInputChange(e, "last_name")}
                className={errors["last_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["last_name"]}</small>
          </div>
          {/* Email */}
          <div className="field col-12 md:col-6">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={globleUserData.email || ""}
                name="email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "email")}
                className={errors["email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["email"]}</small>
          </div>
          {/* Phone */}
          <div className="field col-12 md:col-6">
            <label htmlFor="phone">Phone *</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">+1</span>
              <InputText
                value={globleUserData.phone || ""}
                name="phone"
                autoComplete="off"
                placeholder="Enter Phone Number"
                onChange={(e) => onInputChange(e, "phone")}
                className={errors["phone"] && "p-invalid"}
                keyfilter="pint"
                maxLength={10}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["phone"]}</small>
          </div>

          {/* Postal Code */}
          <div className="field col-12 md:col-6">
            <label htmlFor="postal_code">Postal Code *</label>
            <div className="input-effect-div">
              <InputText
                value={globleUserData.postal_code || ""}
                name="postal_code"
                autoComplete="off"
                placeholder="Enter Postal Code"
                onChange={(e) => onInputChange(e, "postal_code")}
                className={errors["postal_code"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["postal_code"]}</small>
          </div>

          {/* client charge payment by */}
          <div className="field col-12 md:col-4">
            <label htmlFor="client_charge_payment_by ">Client Charge Payment By </label>
            <span className="required"> *</span>
            <div className="flex gap-4 mt-2">
              <div className="flex align-items-center">
                <RadioButton
                  inputId="client_charge_payment_by"
                  name="client_charge_payment_by"
                  value="User"
                  onChange={(e) => onInputChange(e, "client_charge_payment_by")}
                  checked={globleUserData?.client_charge_payment_by === "User"}
                />
                <label htmlFor="User" className="ml-2">
                  User
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="client_charge_payment_by"
                  name="client_charge_payment_by"
                  value="Client"
                  disabled={true}
                  onChange={(e) => onInputChange(e, "client_charge_payment_by")}
                  checked={globleUserData?.client_charge_payment_by === "Client"}
                />
                <label htmlFor="Client" className="ml-2">
                  Client
                </label>
              </div>
            </div>
            <small className="p-invalid-txt">{errors["client_charge_payment_by"]}</small>
          </div>

          {/* Address */}
          <div className="field col-12 md:col-12">
            <label htmlFor="address">Address *</label>
            <div className="input-effect-div">
              <InputTextarea
                rows={2}
                value={globleUserData.address || ""}
                name="address"
                autoComplete="off"
                placeholder="Enter Address"
                onChange={(e) => onInputChange(e, "address")}
                className={errors["address"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["address"]}</small>
          </div>
        </div>
      </Dialog>
      {/* Delete Dialog */}
      <Dialog
        visible={deleteDialog}
        header="Delete User"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteUser} loading={submitLoading} />
          </div>
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this user?</span>
        </div>
      </Dialog>
    </>
  );
};
export default ManageUser;
